import React from "react";
import Tooltip from "../tooltip.jsx";
import { IS_MOBILE } from "../../../util";

class PhysicalEventIcon extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false
    };
  }

  render() {
    let { styles, scale, color, disabled, useTooltip } = this.props;
    const scaleValue = scale ? "scale(" + scale + ")" : "scale(1.0)";
    const iconStyles = Object.assign(
      {
        position: "relative",
        color: color ? color : null,
        fill: "currentColor",
        fillOpacity: disabled ? 0.54 : 1.0
      },
      styles
    );
    if (useTooltip === undefined) {
      useTooltip = true;
    }

    const onMouseEnter = !IS_MOBILE
      ? () => this.setState({ hovered: true })
      : undefined;
    const onMouseLeave = !IS_MOBILE
      ? () => this.setState({ hovered: false })
      : undefined;

    return (
      <div
        style={iconStyles}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {useTooltip ? (
          <Tooltip show={this.state.hovered} label="Physical event" />
        ) : null}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 0 24 24"
          width="24px"
          fill="currentColor"
        >
          <g transform={scaleValue}>
            <path d="M0 0h24v24H0z" fill="none" />
          </g>
          <g transform={scaleValue}>
            <path d="M12 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-1.8C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z" />
          </g>
        </svg>
      </div>
    );
  }
}

export default PhysicalEventIcon;



// WEBPACK FOOTER //
// ./src/app/components/partials/icons/physical-event-icon.jsx